import React, { useContext, useEffect, useState } from 'react';
import { ajaxActions } from '../AjaxActions';
import { AuthS } from '../restapi/authService';
import ProfileSection from '../../Molecules/ProfileSection';
import { AuthContext } from './AuthContext';

export const BankAccountContext = React.createContext(undefined);

export const BankAccountContextProvider = () => {
  const { jwtClaims } = useContext(AuthContext);
  const [bankAccount, setBankAccount] = useState();
  const { profileId } = jwtClaims;

  useEffect(() => {
    if (profileId) {
      AuthS.getBankAccount(profileId).then((resp) => {
        if (resp.ok) {
          resp.json().then(setBankAccount);
        }
      });
    }
  }, [profileId]);

  const handleBankAccountChange = (patch) => {
    setBankAccount((prevState) => ({
      ...prevState,
      ...patch,
    }));
  };

  return (
    <BankAccountContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        bankAccount,
        handleBankAccountChange,
        saveBankAccountChange: async (patch) => {
          const res = await ajaxActions.patch(
            `${process.env.REACT_APP_AUTH_SERVICE_URL}/profiles/${profileId}/bankAccount`,
            patch,
          );
          if (res.ok) {
            handleBankAccountChange(patch);
            return true;
          }
          return false;
        },
      }}
    >
      <ProfileSection />
    </BankAccountContext.Provider>
  );
};
